<a>
  <span ng-bind-html="match.label | uibTypeaheadHighlight:query"></span>
</a>
